export default __webpack_public_path__ + "static/media/3132 utensils top.3a54fe3e.png";